import React from 'react';
import { Select } from 'antd';

const DEBOUNCING_DELAY_IN_MS = 1000;

// This component will have the exact same API as ant Select
// Except for it has a beforeSearch prop which is run before
// The debounced search and an afterSearch prop which is run after
class DebouncedSearch extends React.Component {
  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  handleSearch = query => {
    if (this.props.beforeSearch) {
      this.props.beforeSearch(query);
    }
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.props.onSearch(query);
      if (this.props.afterSearch) {
        this.props.afterSearch(query);
      }
    }, DEBOUNCING_DELAY_IN_MS);
  };

  render() {
    const { children, onSearch, beforeSearch, afterSearch, ...rest } = this.props;

    return (
      <Select {...rest} onSearch={this.handleSearch}>
        {children}
      </Select>
    );
  }
}

export default DebouncedSearch;
